// Generated by scripts/generate_latest_articles.mjs. Do not edit by hand.

export interface LatestArticle {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  category: 'Power Generation' | 'Renewable Energy' | 'Oil & Gas';
  date: string;
  readTime: string;
  trending: boolean;
}

export const latestArticles: LatestArticle[] = [
  {
    "id": "prepaid-meter-map-refund-nigeria",
    "title": "Prepaid Meter Refund Nigeria: Check Your MAP Tokens (2026)",
    "slug": "prepaid-meter-map-refund-nigeria",
    "excerpt": "Paid for a MAP prepaid meter? Find official Ikeja, Eko and AEDC refund portals, retrieve your electricity tokens, understand the repayment schedule and resolve missing credits.",
    "category": "Power Generation",
    "date": "October 23, 2026",
    "readTime": "9 min read",
    "trending": true
  },
  {
    "id": "solar-battery-not-charging-fully-nigeria",
    "title": "Solar Battery Not Charging Fully? Causes and Fixes for Nigerian Homes",
    "slug": "solar-battery-not-charging-fully-nigeria",
    "excerpt": "Sunny day, half-full battery? Check solar production, daytime loads, charging permissions and battery condition, with a practical harmattan checklist for 2026/27.",
    "category": "Renewable Energy",
    "date": "October 23, 2026",
    "readTime": "9 min read",
    "trending": true
  },
  {
    "id": "prepaid-meter-units-finish-fast-nigeria-2026",
    "title": "Why Do My Prepaid Meter Units Finish So Fast? 2026 Nigeria Fix",
    "slug": "prepaid-meter-units-finish-fast-nigeria",
    "excerpt": "Are your electricity units disappearing faster than before? Learn how to calculate appliance consumption, audit your token receipt, find hidden loads, test for wiring faults, and challenge a genuinely faulty meter in Nigeria.",
    "category": "Power Generation",
    "date": "August 30, 2026",
    "readTime": "10 min read",
    "trending": true
  }
];
